<template>
 <!-- Container (Contact Section) -->
 <div class="w3-content w3-container w3-padding-64" id="contact">
    <h3 class="w3-center">CONTACT US</h3>

    <div class="w3-row w3-padding-32 w3-section">
      <div class="w3-col m4 w3-container">
      </div>
      <div class="w3-col m8 w3-panel">
        <div class="w3-large w3-margin-bottom">
          <i
            class="fa fa-map-marker fa-fw w3-hover-text-black w3-xlarge w3-margin-right"
          ></i>
          東京都新宿区大久保 1-7-26<br />
          <i
            class="fa fa-map-marker fa-fw w3-hover-text-black w3-xlarge w3-margin-right"
          ></i>
          1-7-26 Okubo, Shinjuku-Ku, Tokyo, Japan<br />
          <i
            class="fa fa-map-marker fa-fw w3-hover-text-black w3-xlarge w3-margin-right"
          ></i>
          일본 동경 신주쿠구 오쿠보 1-7-26<br />
          <i
            class="fa fa-map-marker fa-fw w3-hover-text-black w3-xlarge w3-margin-right"
          ></i>
          日本东京都新宿区大久保 1-7-26<br />
          <i
            class="fa fa-phone fa-fw w3-hover-text-black w3-xlarge w3-margin-right"
          ></i>
          Phone: 81 - (03) 5155-2651<br />
          <i
            class="fa fa-envelope fa-fw w3-hover-text-black w3-xlarge w3-margin-right"
          ></i>
          Email: sophiearth@naver.com<br />
        </div>
      </div>
    </div>
  </div>
  </template>

<script>
export default {
  components: {
  },
};
</script>

<style>
.active {
  color: red;
}
</style>